import React from 'react';
import { AiOutlineShoppingCart, AiOutlineHeart, AiOutlineEye } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { Global } from '../../Variables/Global';


const OnSaleProductAR = (props) => {
    return (

        <div className="gf-product tab-slider-sub-product">
            <div className="image">
                {!props.product.InStock && (
                    <span className="out-of-stock-badge">
                        نفد من المخزون
                    </span>
                )}
                <span href={"/AR/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>
                    {/* <span className="onsale">Sale!</span> */}
                    {/* <img width="350" height="350" src="assets/images/PRODUCTS PICTURES FOR WEB/JALLAB - SYRUP/MULBERRY SYRUP (500 ML)/MULBERRY SYRUP (500 ML) 1.jpg" className="img-fluid" alt="" /> */}
                    {
                        props.product.DefaultVariation.Image2 == "" ? (
                            <Link to={"/AR/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>
                                <img src={Global.PHOTO_URL + props.product.DefaultVariation.Image1} alt={props.product.ProductName} />
                                {/* onMouseOver={e => (e.currentTarget.src = Global.PHOTO_URL + product.Image1)}
              onMouseOut = {e => (e.currentTarget.src = Global.PHOTO_URL + product.Image0)}  */}
                            </Link>
                        ) : (
                            <Link to={"/AR/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>
                                <img src={Global.PHOTO_URL + props.product.DefaultVariation.Image1} alt={props.product.ProductName}
                                    onMouseOver={e => (e.currentTarget.src = Global.PHOTO_URL + props.product.DefaultVariation.Image2)}
                                    onMouseOut={e => (e.currentTarget.src = Global.PHOTO_URL + props.product.DefaultVariation.Image1)}
                                />

                            </Link>
                        )
                    }
                </span>
                <div className="product-hover-icons">
                    <a data-tooltip="اضف الى السلة" href={"/AR/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>

                        <AiOutlineShoppingCart className='mb-1' color='white' />
                    </a>

                    {
                        props.WishListItems.find(obj => obj.ProductId === props.product.ProductId) ? (
                            <a data-tooltip="إزالة من المفضلة" onClick={() => props.HandleRemoveFromWishList(props.product.ProductId)}>
                                <AiOutlineHeart className='mb-1' style={{ color: 'white' }} />
                            </a>
                        ) : (
                            <a data-tooltip="اضف الى المفضلة" onClick={() => props.HandleAddToWishList(props.product.ProductId, props.product.DefaultVariation.ProductVariationId)}>
                                <AiOutlineHeart className='mb-1' style={{ color: 'white' }} />
                            </a>
                        )
                    }
                    {/* <a data-tooltip="Quick view" data-bs-toggle="modal"
                                            data-bs-target="#quick-view-modal-container">
                                            <AiOutlineEye className='mb-1' color='white' />
                                        </a> */}
                </div>
            </div>
            <div className="product-content">
                {/* <div className="product-categories">
                        <a href="shop-left-sidebar.html">JALLAB - SYRUP</a>

                    </div> */}
                <h3 className="product-title">
                    <Link className='RemUnderline' to={"/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>
                        {props.product.ProductNameAR}
                    </Link>
                </h3>
                <div className="price-box">
                    {
                        props.product.DefaultVariation.SalePrice === 0 ? (
                            <>
                                <span className="discounted-price RemUnderline">AED{props.product.DefaultVariation.RegularPrice}</span>

                            </>
                        ) : (
                            <>
                                <span className="main-price RemUnderline">AED{props.product.DefaultVariation.SalePrice}</span>
                                <span className="discounted-price RemUnderline">AED{props.product.DefaultVariation.RegularPrice}</span>
                            </>
                        )
                    }

                </div>
            </div>

        </div>

    )
}

export default OnSaleProductAR